var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJeans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.539,
    height: 29.241,
    viewBox: "0 0 13.539 29.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#211c51",
    d: "M150.6 2.393l-.05-.049V.458a.458.458 0 0 0-.456-.458h-11.721a.458.458 0 0 0-.458.458v1.885l-.05.049a1.423 1.423 0 0 0-.4 1.049L138.4 28.8a.458.458 0 0 0 .458.441h4.4a.458.458 0 0 0 .458-.458V9.248a.519.519 0 0 1 1.038 0v19.535a.458.458 0 0 0 .458.458h4.4a.458.458 0 0 0 .458-.441L151 3.441a1.422 1.422 0 0 0-.4-1.048zM147.133.916h2.5v1.039h-2.503zm-8.3 0h2.5v1.037h-2.5zm-.451 2.492a.519.519 0 0 1 .519-.538h1.459v.519a1.986 1.986 0 0 1-1.9 1.982zm5.4 4.482a1.437 1.437 0 0 0-.977 1.359v19.076h-3.5l-.816-22.04a2.9 2.9 0 0 0 2.786-2.9v-.516h2.5v5.02zm-1.526-5.936V.916h3.968v1.037h-3.968zm6.915 26.372h-3.5V9.248a1.437 1.437 0 0 0-.977-1.359v-5.02h2.5v.519a2.9 2.9 0 0 0 2.786 2.9zm.85-22.955a1.986 1.986 0 0 1-1.9-1.982v-.52h1.459a.519.519 0 0 1 .519.538z",
    transform: "translate(0 0) translate(0 0) translate(-137.463)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeans);
export default __webpack_public_path__ + "static/media/jeans.7609b167.svg";
export { ForwardRef as ReactComponent };